import { render, staticRenderFns } from "./LayerTableAttributeAction.vue?vue&type=template&id=bc1db96e"
import script from "./LayerTableAttributeAction.vue?vue&type=script&lang=js"
export * from "./LayerTableAttributeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports